import { DateTime } from "luxon";

/**
 * ユーザーのローカルタイムゾーンを取得
 */
export const getUserTimeZone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * UTC日付をローカルタイムゾーンの日付に変換する
 * @param date UTC Dateオブジェクト
 * @param timeZone 例: 'Asia/Tokyo'
 */
export const convertToTimeZone = (date: Date, timeZone: string = getUserTimeZone()): DateTime => {
  return DateTime.fromJSDate(date).setZone(timeZone);
};

/**
 * 任意のDateをその月の1日（ローカルタイムゾーン）に変換
 */
export const getMonthStartDateTimeInZone = (date: Date | string, timeZone: string): DateTime => {
  return DateTime.fromJSDate(new Date(date), { zone: timeZone }).startOf("month");
};
